import { Button, Theme, useMediaQuery } from '@mui/material';
import { useEffect } from 'react';
import { usePopover } from 'src/hooks/use-popover';
import { useViewContextName } from 'src/hooks/use-view-context-name';
import { Briefcase as BriefcaseIcon } from 'src/icons/briefcase';
import { ChevronDown } from 'src/icons/chevron-down';
import { createOutsideClickHandler } from 'src/utils/create-outside-click-handler';
import { AvailableSitesPopper } from '../molecules/available-sites-popper';
import { lightPrimary } from 'src/colors';

export const SiteSelector = () => {
  const getViewContextName = useViewContextName();

  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('md'),
  );

  const [
    siteMenuAnchorRef,
    openSiteMenu,
    handleOpenSiteMenu,
    handleCloseSiteMenu,
  ] = usePopover();

  useEffect(() => {
    createOutsideClickHandler([siteMenuAnchorRef], handleCloseSiteMenu);
  }, []);

  return (
    <>
      <Button
        color="primary"
        onClick={openSiteMenu ? handleCloseSiteMenu : handleOpenSiteMenu}
        ref={siteMenuAnchorRef}
        size={isMobile ? 'medium' : 'large'}
        variant="text"
        startIcon={
          <BriefcaseIcon
            fontSize="small"
            sx={{
              display: {
                xs: 'none',
                sm: 'inline',
              },
              color: lightPrimary.contrast,
              '&:hover': {
                color: lightPrimary.contrast,
              },
              width: '16px',
            }}
          />
        }
        endIcon={<ChevronDown fontSize="small" />}
        sx={{
          ml: 1,
          mr: 2,
          alignItems: 'center',
          fontWeight: 400,
          color: lightPrimary.contrast,
          '&:hover': {
            color: 'lightPrimary.contrast',
          },
          '&:active': {
            color: 'lightPrimary.contrast',
          },
          '&:focus': {
            color: 'lightPrimary.contrast',
          },
          fontSize: {
            md: '14px',
            xs: '12px',
          },
        }}>
        {getViewContextName()}
      </Button>

      <AvailableSitesPopper
        anchorRef={siteMenuAnchorRef}
        open={openSiteMenu}
        onClose={handleCloseSiteMenu}
        placement="bottom-end"
      />
    </>
  );
};
